import axios from 'axios';

const surveyShareApi = {
  async getSurveyShares(surveyKey) {
    const response = await axios.get('/api/tenant/surveyshare/bysurvey/' + surveyKey);
    return response.data;
  },
  async getSurveyShare(key) {
    const response = await axios.get(`/api/tenant/surveyshare/${key}`);
    return response.data;
  },
  async createSurveyShare(surveyShare) {
    const response = await axios.post('/api/tenant/surveyshare', surveyShare);
    return response.data;
  },
  async updateSurveyShare(surveyShare) {
    const response = await axios.put(`/api/tenant/surveyshare/${surveyShare.key}`, surveyShare);
    return response.data;
  },
  async deleteSurveyShare(key) {
    const response = await axios.delete(`/api/tenant/surveyshare/${key}` + key);
    return response.data;
  },
  async sendSurveyShare(surveyShare, /* String[] */ emails, /* Language */ language) {
    const response = await axios.post(`/api/tenant/surveyshare/${surveyShare.key}/send`, {emails, language});
    return response.data;
  },


};

export default surveyShareApi;
